import gsap from "gsap";
// import { gameAssets } from "./gameUI"
// import { settings } from "../settings"
// import { playBigAudio, playEnkCAudio, playEnkDAudio, playMegaAudio, playMiniAudio, playUltraAudio } from "./soundManager"
// import { COMMENDATION } from "./constants"
// import { incrementValue, tweenFade, tweenFadeAppear, tweenScaleAppear, tweenScaleDisAppear } from "./utility"
// import { commendationType, setCommendationType } from "./animations"
// import { winningAmount } from "./networkService"

import {
  incrementValue,
  tweenFade,
  tweenScaleAppear,
  tweenScaleDisAppear,
} from "./utility";
import { checkGrandJackpotVisible, controlJackpotWinSpine, restartGame } from "./gameUI";
import {
  playBigAudio,
  playEnkCAudio,
  playEnkDAudio,
  playMajorAudio,
  playMegaAudio,
  playMiniAudio,
  playUltraAudio,
  stopActiveSound,
} from "./soundManager";
import { globalData } from "./globalData";
import { instances } from "./gameUI";
import { playCoinAnimation, stopCoinAnimation } from "./coins";

const animationArray = [
  "jackpot/fx_in", //0
  "jackpot/fx_loop",
  "jackpot/fx_out",
  "big_win_in", // 3
  "big_win_loop",
  "big_win_out",
  "mega_win_in", // 6
  "mega_win_loop",
  "mega_win_out",
  "ultra_win_in", // 9
  "ultra_win_loop",
  "ultra_win_out",
  "jackpot/minor_in", // 12
  "jackpot/minor_loop",
  "jackpot/minor_out",
  "jackpot/major_in", // 15
  "jackpot/major_loop",
  "jackpot/major_out",
  "jackpot/grand_in", //18
  "jackpot/grand_loop",
  "jackpot/grand_out",
];

const newWinAnimations = ["version 1/bigwin", "version 1/bigwin_and_megawin", "version 1/bigwin_and_megawin_and_ultrawin"]

export const COMMENDATION = Object.freeze({
  NONE: "none",
  NORMAL: "normal",
  BIG: "big",
  MEGA: "mega",
  ULTRA: "ultra",
  MINOR: "minor",
  MAJOR: "major",
  GRAND: "grand",
});

let flag = true;

export let commendationType = COMMENDATION.NONE;
export const setCommendationType = (c) => (commendationType = c);

let delayedCalls = [];
const listeners = [];
let delayedCall = null,
  commendationAmount = 0;

let loopCalls = [];
let loopCall = null;
let trackAnimation = null;
let fontChangedToSilver = false;

let duration = 0;

const stopDelayedCalls = () => {
  delayedCalls.forEach((c) => {
    if (c) c.kill();
  });
  delayedCall = null;
  delayedCalls = [];
}

const stopNumberCounter = (textObject, amt) => {
  globalData.showWinAmount = false;

  stopDelayedCalls()
  textObject.visible = true
  gsap.killTweensOf(textObject);
  textObject.scale.set(1);
  textObject.text = amt;
}

const setUpAnimation = (spineObject, animationIndex, isLoop) => {
  const animation = animationArray[animationIndex];

  if (animation) {
    // const spineObject = animationIndex < 3 ? gameAssets.amazing : gameAssets.commendation

    spineObject.visible = true;
    spineObject.state.setAnimation(0, animation, isLoop);
    // spineObject.resize(settings.currentWidth, settings.currentHeight)
  } else {
    console.warn(`Animation at index ${animationIndex} not found.`);
  }
};

const setupNewWinAnimation = (spineObject, animationIndex, isLoop, backgroundBlur, textObject) => {
  const animation = newWinAnimations[animationIndex];

  if (animation) {
    spineObject.visible = true;

    trackAnimation = spineObject.state.setAnimation(0, animation, isLoop);

    const checkFontChange = setInterval(() => {
      if (!trackAnimation || trackAnimation.isComplete()) {
        clearInterval(checkFontChange);
        return;
      }

      if (animationIndex === 0) clearInterval(checkFontChange);

      if (trackAnimation.trackTime >= 15 && flag) {
        console.log("Changing font to Gold");

        textObject.fontName = "gold-font";

        clearInterval(checkFontChange);
      } else if (trackAnimation.trackTime >= 7 && !fontChangedToSilver && flag) {
        textObject.fontName = "silver-font";

        if (animationIndex === 1) clearInterval(checkFontChange)
        fontChangedToSilver = true;

      }
    }, 100);


    if (trackAnimation && trackAnimation.animation) {
      duration = trackAnimation.animation.duration;
    }

    trackAnimation.listener = {
      complete: () => {

        stopCoinAnimation();
        if (!flag) {
          stopActiveSound();
          playEnkCAudio()
        }
        clearInterval(checkFontChange)
        tweenScaleDisAppear(textObject, 0.1);
        backgroundBlur.interactive = false;
        backgroundBlur.visible = false;
        spineObject.interactive = false;
        spineObject.visible = false;
        duration = 0;
        flag = true;
        fontChangedToSilver = false;

        listeners.forEach((listener) => spineObject.off("pointerdown", listener));
        stopDelayedCalls()

        if (!globalData.jackpot) {
          tweenFade(backgroundBlur, false, 0.2);
          restartGame()
        } else {
          instances.WinsScreen.jackpot()
        }
      }
    };
  } else {
    console.warn(`Animation at index ${animationIndex} not found.`);
  }
};



// export const normalWin = (amt = '0') => {
//     commendationAmount = amt
//     playMiniAudio(true)
//     tweenFade(gameAssets.dimmer, true, 0.2)

//     delayedCall = gsap.delayedCall(1.5, () => {
//         gameAssets.amazingWinValueBitmap.text = 0
//         tweenFadeAppear(gameAssets.amazingBitmap, true, 0.2)
//         tweenScaleAppear(gameAssets.amazingWinValueBitmap, 0.5, () => {
//             delayedCall = gsap.delayedCall(0.2, ()=> increaseNumCount(gameAssets.amazingWinValueBitmap, amt))
//             delayedCalls.push(delayedCall)
//         })
//     })
//     delayedCalls.push(delayedCall)

//     setUpAnimation(gameAssets.amazing, 0, false)
//     delayedCall = gsap.delayedCall(2, ()=>{
//         setUpAnimation(gameAssets.amazing, 1, true)
//     })
//     delayedCalls.push(delayedCall)

//     delayedCall = gsap.delayedCall(9, ()=>{
//         setUpAnimation(gameAssets.amazing, 2, false)
//         tweenFadeAppear(gameAssets.amazingBitmap, false)
//         tweenScaleDisAppear(gameAssets.amazingWinValueBitmap, false)
//         if(commendationType === COMMENDATION.NORMAL) {
//             playEnkCAudio(true)
//             setCommendationType(COMMENDATION.NONE)
//             tweenFade(gameAssets.dimmer, false, 0.2)
//             delayedCall = null
//             delayedCalls = []
//             commendationAmount = 0
//         }
//     })
//     delayedCalls.push(delayedCall)
// }

export const bigWin = (backgroundBlur, textObject, amt, gameObject) => {
  commendationAmount = amt;
  gameObject.interactive = true;
  globalData.showWinAmount = true;
  playBigAudio();
  playCoinAnimation(0)
  tweenFade(backgroundBlur, true, 0.2);

  setupNewWinAnimation(gameObject, 0, false, backgroundBlur, textObject);

  delayedCall = gsap.delayedCall(1.5, () => {
    textObject.visible = true;
    textObject.text = 0;

    tweenScaleAppear(textObject, 0.5, () => {
      delayedCall = gsap.delayedCall(0.2, () =>
        increaseNumCount(textObject, amt, duration)
      );
      delayedCalls.push(delayedCall);
    });
  });
  delayedCalls.push(delayedCall);


  const pointerDownListener = () => {
    if (globalData.showWinAmount) {
      stopNumberCounter(textObject, amt);
    } else if (flag) {
      trackAnimation.trackTime = 6;
      flag = false;
    }
  };

  gameObject.on("pointerdown", pointerDownListener);
  listeners.push(pointerDownListener);


  // setUpAnimation(gameObject, 3, false);

  // delayedCall = gsap.delayedCall(2, () => {
  //   setUpAnimation(gameObject, 4, true);
  // });
  // delayedCalls.push(delayedCall);

  // delayedCall = gsap.delayedCall(7.5, () => {
  //     setUpAnimation(gameObject, 5, false);
  //     tweenScaleDisAppear(textObject, false);
  //     stopCoinAnimation()
  //     textObject.visible = false;
  //     listeners.forEach((listener) => gameObject.off("pointerdown", listener));
  //     if (commendationType === COMMENDATION.BIG) {
  //       playEnkDAudio();
  //       globalData.winComplete = false;
  //       gameObject.interactive = false;
  //       backgroundBlur.interactive = false;
  //       if(!globalData.jackpotMajorWin && !globalData.jackpotGrandWin && !globalData.jackpotMinorWin){
  //         delayedCall = null;
  //         delayedCalls = [];
  //         tweenFade(backgroundBlur, false, 0.2);
  //       restartGame();
  //     } else {
  //       instances.WinsScreen.jackpot()
  //     }
  //     }
  // });
  // delayedCalls.push(delayedCall);
};


export const megaWin = (backgroundBlur, textObject, amt, gameObject) => {
  playMegaAudio();
  playCoinAnimation(1);
  gameObject.interactive = true;
  globalData.showWinAmount = true;
  tweenFade(backgroundBlur, true, 0.2);


  setupNewWinAnimation(gameObject, 1, false, backgroundBlur, textObject)

  delayedCall = gsap.delayedCall(1.5, () => {
    textObject.visible = true;
    textObject.text = 0;
    tweenScaleAppear(textObject, 0.5, () => {
      delayedCall = gsap.delayedCall(0.2, () =>
        increaseNumCount(textObject, amt, duration)
      );
      delayedCalls.push(delayedCall);
    });
  });
  delayedCalls.push(delayedCall);

  const pointerDownListener = () => {
    if (globalData.showWinAmount) {
      stopNumberCounter(textObject, amt)
    } else if (flag) {
      textObject.fontName = "silver-font"
      trackAnimation.trackTime = 14;
      flag = false;
    }
  };
  gameObject.on("pointerdown", pointerDownListener);
  listeners.push(pointerDownListener);


  // setUpAnimation(gameObject, 6, false);
  // delayedCall = gsap.delayedCall(2, () => {
  //   setUpAnimation(gameObject, 7, true);
  // });
  // delayedCalls.push(delayedCall);

  // delayedCall = gsap.delayedCall(7.5, () => {
  //   setUpAnimation(gameObject, 8, false);
  //   tweenScaleDisAppear(textObject, false);
  //   stopCoinAnimation()
  //   textObject.visible = false;
  //   listeners.forEach((listener) => gameObject.off("pointerdown", listener));
  //   if (commendationType === COMMENDATION.MEGA) {
  //     playEnkDAudio();
  //     textObject.visible = false;
  //     gameObject.interactive = false;
  //     backgroundBlur.interactive = false;
  //     commendationAmount = 0;
  //     globalData.winComplete = false;
  //     if(!globalData.jackpotMajorWin && !globalData.jackpotGrandWin && !globalData.jackpotMinorWin){
  //       delayedCall = null;
  //       delayedCalls = [];

  //       tweenFade(backgroundBlur, false, 0.2);
  //      restartGame();
  //   } else {

  //     instances.WinsScreen.jackpot()
  //   }
  //   }
  // });
  // delayedCalls.push(delayedCall);

};



export const ultraWin = (backgroundBlur, textObject, amt, gameObject) => {

  playUltraAudio();
  playCoinAnimation(2)
  tweenFade(backgroundBlur, true, 0.2)
  globalData.showWinAmount = true;
  gameObject.interactive = true;

  setupNewWinAnimation(gameObject, 2, false, backgroundBlur, textObject)


  delayedCall = gsap.delayedCall(1.5, () => {
    textObject.visible = true;
    textObject.text = 0;
    tweenScaleAppear(textObject, 0.5, () => {
      delayedCall = gsap.delayedCall(0.2, () =>
        increaseNumCount(textObject, amt, duration)
      );
      delayedCalls.push(delayedCall);
    });
  });
  delayedCalls.push(delayedCall);

  const pointerDownListener = () => {

    if (globalData.showWinAmount) {
      stopNumberCounter(textObject, amt)
    } else if (flag) {
      textObject.fontName = "gold-font"
      trackAnimation.trackTime = 22;
      flag = false;
    }
  };

  gameObject.on("pointerdown", pointerDownListener);
  listeners.push(pointerDownListener);

  // setUpAnimation(gameObject, 9, false);
  // delayedCall = gsap.delayedCall(2, () => {
  //   setUpAnimation(gameObject, 10, true);
  // });
  // delayedCalls.push(delayedCall);

  // delayedCall = gsap.delayedCall(9, () => {
  //   setUpAnimation(gameObject, 11, false);
  //   tweenScaleDisAppear(textObject, false);
  //   stopCoinAnimation()
  //   textObject.visible = false;
  //   listeners.forEach((listener) => gameObject.off("pointerdown", listener));

  //   if (commendationType === COMMENDATION.ULTRA) {
  //     textObject.visible = false;
  //     globalData.winComplete = false;
  //     gameObject.interactive = false;
  //     backgroundBlur.interactive = false;
  //     playEnkDAudio();

  //     commendationAmount = 0;
  //     if(!globalData.jackpotMajorWin && !globalData.jackpotGrandWin && !globalData.jackpotMinorWin){
  //       delayedCall = null;
  //       delayedCalls = [];


  //       tweenFade(backgroundBlur, false, 0.2);
  //      restartGame();
  //   } else {
  //     instances.WinsScreen.jackpot()
  //   }
  //   }
  // });
  // delayedCalls.push(delayedCall);

};



export const minorJackpot = (gameObject, amt, backgroundBlur, textObject) => {
  globalData.jackpotMinorWin = false;
  globalData.showAmount = true;
  commendationAmount = amt;
  gameObject.interactive = true;
  playMiniAudio();
  playCoinAnimation(0)
  tweenFade(backgroundBlur, true, 0.2);

  delayedCall = gsap.delayedCall(1.5, () => {
    textObject.visible = true;
    textObject.text = 0;

    tweenScaleAppear(
      textObject,
      0.5,
      () =>
      (delayedCall = gsap.delayedCall(0.2, () =>{
        if(!globalData.showAmount) return;
        increaseNumCount(textObject, amt)
      }
      ))
    );
  });
  delayedCalls.push(delayedCall);

  const pointerDownListener = () => {
    clickToStopCommendation(backgroundBlur, gameObject, textObject, amt, 14);
  };

  gameObject.on("pointerdown", pointerDownListener);
  listeners.push(pointerDownListener);


  setUpAnimation(gameObject, 12, false);
  loopCall = gsap.delayedCall(2, () => {
    setUpAnimation(gameObject, 13, true);
  });
  loopCalls.push(loopCall);

  delayedCall = gsap.delayedCall(9, () => {
    setUpAnimation(gameObject, 14, false);


    listeners.forEach((listener) => gameObject.off("pointerdown", listener));
    if (globalData.jackpotMajorWin) {
      textObject.fontName = "silver-font";
      globalData.jackpotMinorWin = false;
      controlJackpotWinSpine(0, false);
      controlJackpotWinSpine(1, true);
      majorJackpot(gameObject, globalData.jackpotMajorWinAmount, backgroundBlur, textObject);
      setCommendationType(COMMENDATION.MAJOR)

    } else if (globalData.jackpotGrandWin) {
      globalData.jackpotMinorWin = false;
      textObject.fontName = "gold-font";
      controlJackpotWinSpine(0, false);
      controlJackpotWinSpine(2, true);
      grandJackpot(gameObject, globalData.jackpotGrandWinAmount, backgroundBlur, textObject);
      setCommendationType(COMMENDATION.GRAND)
    }

    tweenScaleDisAppear(textObject, false);
    stopCoinAnimation();
    if (commendationType === COMMENDATION.MINOR) {
      playEnkCAudio();
      setCommendationType(COMMENDATION.NONE);
      tweenFade(backgroundBlur, false, 0.2);
      commendationAmount = 0;
      delayedCall = null;
      delayedCalls = [];

      loopCalls = [];
      loopCall = null;
      textObject.visible = false;
      gameObject.visible = false;
      gameObject.interactive = false;
      backgroundBlur.interactive = false;
      restartGame()
    }
  });
  delayedCalls.push(delayedCall);
};



export const majorJackpot = (gameObject, amt, backgroundBlur, textObject) => {
  globalData.jackpotMajorWin = false;
  globalData.showAmount = true;
  commendationAmount = amt;
  playCoinAnimation(1)
  gameObject.interactive = true
  playMajorAudio();
  tweenFade(backgroundBlur, true, 0.2);

  delayedCall = gsap.delayedCall(1.5, () => {
    textObject.visible = true;
    textObject.text = 0;

    tweenScaleAppear(
      textObject,
      0.5,
      () =>
      (delayedCall = gsap.delayedCall(0.2, () => {
        if(!globalData.showAmount) return;
        increaseNumCount(textObject, amt)
      }
      ))
    );
  });
  delayedCalls.push(delayedCall);

  const pointerDownListener = () => {
    clickToStopCommendation(backgroundBlur, gameObject, textObject, amt, 17);
  };

  gameObject.on("pointerdown", pointerDownListener);
  listeners.push(pointerDownListener);


  setUpAnimation(gameObject, 15, false);
  loopCall = gsap.delayedCall(2, () => {
    setUpAnimation(gameObject, 16, true);
  });
  loopCalls.push(loopCall);

  delayedCall = gsap.delayedCall(9, () => {
    setUpAnimation(gameObject, 17, false);

    listeners.forEach((listener) => gameObject.off("pointerdown", listener));
    if (globalData.jackpotGrandWin) {
      textObject.fontName = "gold-font";
      globalData.jackpotMajorWin = false;
      controlJackpotWinSpine(1, false);
      controlJackpotWinSpine(2, true);
      grandJackpot(gameObject, globalData.jackpotGrandWinAmount, backgroundBlur, textObject);
      setCommendationType(COMMENDATION.GRAND)

    }

    tweenScaleDisAppear(textObject, false);
    if (commendationType === COMMENDATION.MAJOR) {
      playEnkCAudio();
      stopCoinAnimation();
      setCommendationType(COMMENDATION.NONE);
      tweenFade(backgroundBlur, false, 0.2);
      commendationAmount = 0;
      delayedCall = null;
      delayedCalls = [];

      loopCalls = [];
      loopCall = null
      textObject.visible = false;
      gameObject.visible = false;
      gameObject.interactive = false;
      backgroundBlur.interactive = false;
      restartGame();
    }
  });
  delayedCalls.push(delayedCall);
};



export const grandJackpot = (gameObject, amt, backgroundBlur, textObject) => {
  globalData.jackpotGrandWin = false;
  commendationAmount = amt;
  globalData.showAmount = true;
  playCoinAnimation(2)
  gameObject.interactive = true
  playMajorAudio();
  tweenFade(backgroundBlur, true, 0.2);

  delayedCall = gsap.delayedCall(1.5, () => {
    textObject.visible = true;
    textObject.text = 0;
    tweenScaleAppear(
      textObject,
      0.5,
      () =>
      (delayedCall = gsap.delayedCall(0.2, () => {
        if(!globalData.showAmount) return;
        increaseNumCount(textObject, amt)
      }
      ))
    );
  });
  delayedCalls.push(delayedCall);

  const pointerDownListener = () => {
    clickToStopCommendation(backgroundBlur, gameObject, textObject, amt, 20);
  };

  gameObject.on("pointerdown", pointerDownListener);
  listeners.push(pointerDownListener);


  setUpAnimation(gameObject, 18, false);
  loopCall = gsap.delayedCall(2, () => {
    setUpAnimation(gameObject, 19, true);
  });
  loopCalls.push(loopCall);

  delayedCall = gsap.delayedCall(9, () => {
    setUpAnimation(gameObject, 20, false);
    tweenScaleDisAppear(textObject, false);
    stopCoinAnimation();
    listeners.forEach((listener) => gameObject.off("pointerdown", listener));
    if (commendationType === COMMENDATION.GRAND) {
      globalData.jackpotMajorWin = false;
      globalData.jackpotGrandWin = false;
      playEnkCAudio();
      setCommendationType(COMMENDATION.NONE);
      tweenFade(backgroundBlur, false, 0.2);
      commendationAmount = 0;
      delayedCall = null;
      delayedCalls = [];

      loopCalls = [];
      loopCall = null
      textObject.visible = false;
      gameObject.visible = false;
      gameObject.interactive = false;
      backgroundBlur.interactive = false;
      restartGame();
    }

  });
  delayedCalls.push(delayedCall);
};

export const clickToStopCommendation = (
  backgroundBlur,
  gameObject,
  textObject,
  amt,
  index
) => {

  delayedCalls.forEach((c) => {
    if (c) c.kill();
  });
  delayedCall = null;
  delayedCalls = [];

  // gsap.killTweensOf(backgroundBlur);
  // gsap.killTweensOf(gameObject);
  // gsap.killTweensOf(backgroundBlur);
  // playMiniAudio()
  // tweenFade(backgroundBlur, false, 0.2);

  // textObject.text = commendationAmount;
  // setCommendationType(COMMENDATION.NONE)


  if (globalData.showAmount) {

    globalData.showAmount = false;
    textObject.visible = true
    gsap.killTweensOf(textObject);
    textObject.scale.set(1);
    textObject.text = Number(amt).toFixed(2);

    if (globalData.jackpotMinorWin || globalData.jackpotMajorWin || (globalData.jackpotGrandWin && checkGrandJackpotVisible() === false)) {
      delayedCall = gsap.delayedCall(4, () => {
        callJackpot(gameObject, textObject);
      });
      delayedCalls.push(delayedCall);
    } else {
      delayedCall = gsap.delayedCall(4, () => {
        clearGame(gameObject, textObject, backgroundBlur, index);
      });

      delayedCalls.push(delayedCall);
    }
  } else if (globalData.jackpotMinorWin || globalData.jackpotMajorWin || globalData.jackpotGrandWin) {

    callJackpot(gameObject, textObject);
  } else {

    clearGame(gameObject, textObject, backgroundBlur, index);
  }

};

const clearGame = (gameObject, textObject, backgroundBlur, index) => {
  stopCoinAnimation()

  setUpAnimation(gameObject, index, false)

  delayedCalls.forEach((c) => {
    if (c) c.kill();
  });
  delayedCall = null;
  delayedCalls = [];

  loopCalls.forEach((c) => {
    if (c) c.kill();
  })
  loopCall = null;
  loopCalls = []

  listeners.forEach((listener) => gameObject.off("pointerdown", listener));

  tweenScaleDisAppear(textObject, false);
  backgroundBlur.interactive = false;
  gameObject.visible = false;
  gameObject.interactive = false;
  tweenFade(backgroundBlur, false, 0.2);

  gsap.delayedCall(0.2, () => {
    stopActiveSound()
    playEnkCAudio()
  });

  restartGame();
}

//TODO: JACKPOT CALL 1
const callJackpot = (gameObject, textObject) => {
  loopCalls.forEach((c) => {
    if (c) c.kill();
  })
  loopCall = null;
  loopCalls = []

  stopCoinAnimation()
  gameObject.visible = false;
  textObject.visible = false;
  gameObject.interactive = false;
  listeners.forEach((listener) => gameObject.off("pointerdown", listener));
  instances.WinsScreen.jackpot();
}

const increaseNumCount = (textGameObject, value, duration = 8) => {
  textGameObject.text = 0;
  incrementValue(
    textGameObject,
    value, //winningAmount(),
    duration
  );
};
